import React from 'react'
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import { advancedColors } from '../theme'
import {
  ScoredInstance,
  changeColor,
  completionTimeLabel,
  vsPreviousLabel,
  vsPreviousPercent,
} from './questionnaireHistory'

type Props = {
  instances: ScoredInstance[]
  timezone: string | null | undefined
  selectedId: string
  onSelect: (id: string) => void
}

const SurveyCompletionTable = ({ instances, timezone, selectedId, onSelect }: Props) => (
  <Table size="small" stickyHeader aria-label="Past survey completions">
    <TableHead>
      <TableRow>
        <TableCell>Completed</TableCell>
        <TableCell>Score</TableCell>
        <TableCell>Change</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {instances.map((instance, index) => {
        const change = vsPreviousPercent(instance.score, instances[index + 1]?.score ?? null)
        return (
          <TableRow
            key={instance.id}
            hover
            selected={selectedId === instance.id}
            aria-selected={selectedId === instance.id}
            tabIndex={0}
            onClick={() => onSelect(instance.id)}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault()
                onSelect(instance.id)
              }
            }}
            sx={{
              cursor: 'pointer',
              backgroundColor: index % 2 === 1 ? advancedColors.cardBg : advancedColors.surface,
              '&:hover, &.Mui-selected, &.Mui-selected:hover': { backgroundColor: advancedColors.greenSoft },
              '&:focus-visible': { outline: `2px solid ${advancedColors.green}`, outlineOffset: -2 },
            }}
          >
            <TableCell sx={{ whiteSpace: 'nowrap' }}>{completionTimeLabel(instance, timezone)}</TableCell>
            <TableCell>{instance.score ?? '—'}</TableCell>
            <TableCell sx={{ color: changeColor(change) }}>{vsPreviousLabel(change)}</TableCell>
          </TableRow>
        )
      })}
    </TableBody>
  </Table>
)

export default SurveyCompletionTable
